var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehiclesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.5001 21.6667V18.3334H29.6667C28.4259 18.3334 27.8054 18.3334 27.3034 18.1702C26.2886 17.8406 25.4929 17.0449 25.1632 16.0301C25.0001 15.528 25.0001 14.9076 25.0001 13.6667C25.0001 11.8055 25.0001 10.8748 24.7554 10.1217C24.2607 8.59948 23.0674 7.40605 21.5452 6.91146C20.7921 6.66675 19.8614 6.66675 18.0001 6.66675H4.16675L4.21266 25.0001C4.30378 26.8279 4.57568 27.9682 5.38713 28.7797C6.19858 29.5911 7.33888 29.8631 9.16675 29.9541C9.19131 28.1344 10.6745 26.6667 12.5001 26.6667C14.341 26.6667 15.8334 28.1591 15.8334 30.0001H25.8334C25.8334 28.1591 27.3257 26.6667 29.1667 26.6667C30.9924 26.6667 32.4752 28.1344 32.4997 29.9542C34.3276 29.8631 35.4682 29.5911 36.2797 28.7797C37.5001 27.5592 37.5001 25.5951 37.5001 21.6667Z",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 29.9541C7.33888 29.8631 6.19858 29.5911 5.38713 28.7797C4.57568 27.9682 4.30378 26.8279 4.21266 25.0001M15.8334 30.0001H25.8334M32.5001 29.9541C34.3279 29.8631 35.4682 29.5911 36.2797 28.7797C37.5001 27.5592 37.5001 25.5951 37.5001 21.6667V18.3334H29.6667C28.4259 18.3334 27.8054 18.3334 27.3034 18.1702C26.2886 17.8406 25.4929 17.0449 25.1632 16.0301C25.0001 15.528 25.0001 14.9076 25.0001 13.6667C25.0001 11.8055 25.0001 10.8748 24.7554 10.1217C24.2607 8.59948 23.0674 7.40605 21.5452 6.91146C20.7921 6.66675 19.8614 6.66675 18.0001 6.66675H4.16675",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 33.3334C31.0077 33.3334 32.5 31.841 32.5 30.0001C32.5 28.1591 31.0077 26.6667 29.1667 26.6667C27.3258 26.6667 25.8334 28.1591 25.8334 30.0001C25.8334 31.841 27.3258 33.3334 29.1667 33.3334Z",
    stroke: "#172B4D",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 33.3334C14.341 33.3334 15.8334 31.841 15.8334 30.0001C15.8334 28.1591 14.341 26.6667 12.5001 26.6667C10.6591 26.6667 9.16675 28.1591 9.16675 30.0001C9.16675 31.841 10.6591 33.3334 12.5001 33.3334Z",
    stroke: "#172B4D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 13.3333H14.1667",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 18.3333H10.8334",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10H28.0353C30.461 10 31.6737 10 32.6607 10.5895C33.6477 11.179 34.2227 12.2469 35.3727 14.3825L37.5 18.3333",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclesIcon);
export default __webpack_public_path__ + "static/media/vehicles_icon.2c6cf0597572b697354ad053d99b1265.svg";
export { ForwardRef as ReactComponent };